import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../../context/AuthContext';
import { wsUrl, SPEICHER, aufnahmeStarten, befehlAusfuehren, createLatenz } from '../../lib/cobrowse';

const laden = () => { try { return JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); } catch { return null; } };
const ENDE_TEXT = { mandant: 'Sie haben die Bildschirmfreigabe beendet.', kanzlei: 'Die Kanzlei hat die Bildschirmfreigabe beendet.', zeitlimit: 'Die Sitzung wurde nach 2 Stunden automatisch beendet.', abgelaufen: 'Der Code ist abgelaufen.' };

// Mandanten-Seite: Sitzung starten/annehmen, Bildschirm übertragen, Fernsteuerung ausführen
export const useCobrowseSitzung = (pfad) => {
  const [sitzung, setSitzungRoh] = useState(laden);
  const [agent, setAgent] = useState(null);
  const [maus, setMaus] = useState(null);
  const [hinweis, setHinweis] = useState('');
  const [netz, setNetz] = useState({ ms: null, stufe: null });
  const ws = useRef(null);
  const stop = useRef(null);

  const setSitzung = useCallback((s) => {
    if (s) sessionStorage.setItem(SPEICHER, JSON.stringify(s)); else sessionStorage.removeItem(SPEICHER);
    setSitzungRoh(s);
  }, []);
  const aufnahmeStop = () => { stop.current?.(); stop.current = null; };
  const beendet = useCallback((von) => {
    aufnahmeStop(); setSitzung(null); setAgent(null); setMaus(null);
    setHinweis(ENDE_TEXT[von] || 'Die Bildschirmfreigabe ist beendet.');
  }, [setSitzung]);

  useEffect(() => {
    if (!sitzung) return undefined;
    let zu = false; let timer; let puffer = []; let flush = null; let warDa = false; let agentDa = false; let langsam = false; let letzteMaus = 0;
    const senden = (m) => ws.current?.readyState === 1 && ws.current.send(JSON.stringify(m));
    const latenz = createLatenz(senden, (n) => { langsam = n.stufe === 'langsam'; setNetz(n); });
    const aufnahme = () => {
      aufnahmeStop();
      stop.current = aufnahmeStarten((e) => {
        if (langsam && e.type === 3 && e.data?.source === 1) { const j = Date.now(); if (j - letzteMaus < 400) return; letzteMaus = j; }
        puffer.push(e);
        if (!flush) flush = setTimeout(() => { senden({ t: 'ev', e: puffer }); puffer = []; flush = null; }, 80);
      });
      senden({ t: 'nav', pfad: window.location.pathname });
    };
    const verbinden = () => {
      const s = new WebSocket(wsUrl(sitzung.sid, sitzung.token));
      ws.current = s;
      s.onmessage = (ev) => {
        const m = JSON.parse(ev.data);
        if (latenz.handle(m)) return;
        if (m.t === 'agent-da') { warDa = true; agentDa = true; setAgent(m.name || 'Kanzlei'); aufnahme(); latenz.tick(); }
        else if (m.t === 'agent-weg') { agentDa = false; setAgent(null); setMaus(null); aufnahmeStop(); latenz.reset(); }
        else if (m.t === 'ende') { zu = true; beendet(m.von); }
        else if (m.t === 'cmd') befehlAusfuehren(m, setMaus);
      };
      s.onclose = (e) => {
        aufnahmeStop();
        if (e.code === 4403) { zu = true; beendet('system'); }
        else if (!zu && e.code !== 4409) timer = setTimeout(verbinden, 2000);
      };
    };
    verbinden();
    const ping = setInterval(() => senden({ t: 'ping' }), 25000);
    const mess = setInterval(() => { if (agentDa) latenz.tick(); }, 3000);
    const ablauf = sitzung.code ? setTimeout(() => { if (!warDa) { senden({ t: 'ende' }); zu = true; beendet('abgelaufen'); } }, 15 * 60000) : null;
    return () => { zu = true; clearTimeout(timer); clearTimeout(ablauf); clearTimeout(flush); clearInterval(ping); clearInterval(mess); aufnahmeStop(); ws.current?.close(); };
  }, [sitzung, beendet]);

  useEffect(() => {
    if (agent && ws.current?.readyState === 1) ws.current.send(JSON.stringify({ t: 'nav', pfad }));
  }, [pfad, agent]);

  const starten = async () => {
    const r = await api.post('/cobrowse/sitzungen', { zustimmung: true, seite: window.location.pathname });
    setHinweis(''); setSitzung({ sid: r.data.session_id, token: r.data.client_token, code: r.data.code });
  };
  const annehmen = async (einladungId) => {
    const r = await api.post(`/cobrowse/einladung/${einladungId}/annehmen`, { zustimmung: true });
    setHinweis(''); setSitzung({ sid: r.data.session_id, token: r.data.client_token, code: null });
  };
  const beenden = async () => {
    const s = sitzung;
    beendet('mandant');
    await api.post(`/cobrowse/sitzungen/${s.sid}/beenden`, null, { params: { token: s.token } }).catch(() => {});
  };
  return { sitzung, agent, maus, netz, hinweis, setHinweis, starten, annehmen, beenden };
};

export const useEinladung = (aktiv) => {
  const [einladung, setEinladung] = useState(null);
  useEffect(() => {
    if (!aktiv) { setEinladung(null); return undefined; }
    const pruefen = () => { if (!document.hidden) api.get('/cobrowse/einladung').then((r) => setEinladung(r.data || null)).catch(() => {}); };
    pruefen();
    const t = setInterval(pruefen, 20000);
    return () => clearInterval(t);
  }, [aktiv]);
  return [einladung, setEinladung];
};
